import React, { Suspense } from 'react';
import FallBack from '../pages/Root/FallBack';

const withLazyLoad = (importFunc) => {
    const LazyComponent = React.lazy(importFunc)

    return function LazyLoadWrapper(props) {
        return (
            <Suspense fallback={<FallBack />}>
                <LazyComponent {...props} />
            </Suspense>
        );
    };
};

export default withLazyLoad;